<template>
  <v-main class="page-form-main-head-form">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-btn
          icon
          @click="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>{{ $t('form.show.head-form') }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container>
      <FormComponent
        v-model="formData"
        :form="project.formHead"
        type="head"
        :doc-id="project._id"
        @submit="saveForm"
      />
    </v-container>

    <v-dialog
      v-model="confirmGoBackDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">{{ $t('form.goback.title') }}</v-card-title>
        <v-card-text>{{ $t('form.goback.message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelGoBack"
          >
            {{ $t('misc.cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="goBack(true)"
          >
            {{ $t('misc.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import FormComponent from '@/components/FormComponent';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';

export default {
  components: {
    FormComponent
  },
  props: {
    project: { type: Object, required: true },
    projectData: { type: Object, required: true }
  },
  data: () => ({
    internalFormData: null,
    confirmGoBackDialog: false,
    confirmRequired: false,
    leaveResolver: null
  }),
  computed: {
    formData: {
      get () {
        return this.internalFormData || this.project.formHeadData || {};
      },
      set (v) {
        this.internalFormData = v;
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.confirmRequired = true;
    }, 2000);
  },
  beforeRouteLeave (to, from, next) {
    if (document.getElementById('app').classList.contains('barcodescanner-active')) {
      document.getElementById('app').classList.remove('barcodescanner-active');
      next(false);
      BarcodeScanner.stopScan();
      BarcodeScanner.showBackground();
      return;
    }

    if (this.confirmRequired) {
      new Promise((resolve) => {
        this.confirmGoBackDialog = true;

        this.leaveResolver = resolve;
      }).then(result => {
        this.leaveResolver = null;
        if (result) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  methods: {
    goBack (confirm = false) {
      if (confirm) {
        if (this.leaveResolver instanceof Function) {
          this.leaveResolver(true);
        } else {
          this.confirmGoBackDialog = false;
          this.$router.go(-1);
        }

        return;
      }

      this.confirmGoBackDialog = true;
    },
    cancelGoBack () {
      this.confirmGoBackDialog = false;
      if (this.leaveResolver instanceof Function) {
        this.leaveResolver(false);
      }
    },
    async saveForm (v) {
      const loader = this.$loading.show();

      try {
        const doc = await this.$pouch.get(this.project._id, {}, 'projects');
        doc.formHeadData = v;

        let saveBlobsRecursive = async (data, keyPrefix = '') => {
          for (const key in data) {
            if (data[key] && (data[key] instanceof File || (data[key].blob && data[key].blob instanceof Blob))) {
              const file = data[key];
              let blob;
              if (!file.blob) {
                blob = new Blob([await file.arrayBuffer()], { type: file.type });
              } else {
                blob = file.blob;
              }

              const refreshedDoc = await this.$pouch.get(doc._id, {}, 'projects');
              const at = await this.$pouch.putAttachment(doc._id, refreshedDoc._rev, {
                id: keyPrefix + key,
                data: blob,
                type: file.blob.type
              }, 'projects');
              doc._rev = at.rev;

              if (file.blob) {
                data[key] = {
                  fieldType: 'file',
                  name: file.name,
                  customFilename: file.customFilename,
                  size: file.blob.size,
                  type: file.blob.type
                };
              } else {
                data[key] = {
                  fieldType: 'file',
                  name: file.name,
                  size: file.size,
                  type: file.type
                };
              }
            } else if (data[key] && (data[key] instanceof Array || data[key] instanceof Object)) {
              data[key] = await saveBlobsRecursive(data[key], key + '.');
            }
          }

          return data;
        };

        doc.formHeadData = await saveBlobsRecursive(doc.formHeadData);

        const refreshedDoc = await this.$pouch.get(doc._id, {}, 'projects');
        refreshedDoc.formHeadData = doc.formHeadData;
        refreshedDoc.synced = false;

        this.$pouch.put(refreshedDoc, { force: true }, 'projects');
        this.confirmRequired = false;
        this.$router.go(-1);
      } catch (e) {
        console.error(e);
        alert('ERROR');
      }

      loader.hide();
    }
  }
};
</script>
